import { RootState } from 'store';

export const selectPdfForViewer = (id?: string) => (state: RootState) => {
  return id ? state.file.viewerPdf[id] || null : null;
};
